import { render, staticRenderFns } from "./slideLayout.vue?vue&type=template&id=9fb4d740&scoped=true"
import script from "./slideLayout.vue?vue&type=script&lang=js"
export * from "./slideLayout.vue?vue&type=script&lang=js"
import style0 from "./slideLayout.vue?vue&type=style&index=0&id=9fb4d740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb4d740",
  null
  
)

export default component.exports